// The Students cell: the course's student count, linking to its people admin page.

import React from 'react'
import PropTypes from 'prop-types'

import { InlineLink } from '@CommonComponents/buttons'
import { formatNumber, isNumber } from '../../components/me_table/format'

export const studentsLabel = (count, coursenum) =>
  `${count} ${count === '1' ? 'student' : 'students'} in ${coursenum}`

export const StudentsCell = ({ row }) => {
  const count = isNumber(row.students) ? row.students : 0
  const shown = formatNumber(count)
  if (!row.students_href) return shown
  return (
    <InlineLink
      href={row.students_href}
      aria-label={studentsLabel(shown, row.coursenum)}
    >
      {shown}
    </InlineLink>
  )
}

StudentsCell.propTypes = {
  row: PropTypes.shape({
    students: PropTypes.number,
    students_href: PropTypes.string,
    coursenum: PropTypes.string,
  }).isRequired,
}
